export default __webpack_public_path__ + "static/media/activity-new.892e193e.svg";